import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ImmLogo } from "../../assets/images/logoImm";
import { tanzaniaLogo } from "../../assets/images/tanzaniaLogo";
import * as numberToWords from "number-to-words";
import { getEmail} from "../../utility/Common";



pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function generateImmigrationBillPDF(billInfo) {
  return new Promise((resolve, reject) => {
    const userName = getEmail();
    const printedDate = new Date().toLocaleString();
    function amountToWords(amount) {
      return numberToWords.toWords(amount);
    }

    let documentDefinition = {
      content: [
        /*====================================A:PERSONAL DETAILS======================*/
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["*"],
                    body: [
                      //head
                      [
                        {
                          border: [false, false, false, false],
                          table: {
                            widths: ["20%", "*", "20%"],
                            body: [
                              [
                                {
                                  border: [false, false, false, false],
                                  stack: [
                                    {
                                      image:
                                        "data:image/jpeg;base64," +
                                        tanzaniaLogo,
                                      width: 60,
                                      height: 60,
                                      alignment: "left",
                                    },
                                  ],
                                },
                                {
                                  border: [false, false, false, false],
                                  table: {
                                    widths: ["*"],
                                    body: [
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "UNITED REPUBLIC OF TANZANIA",
                                          fontSize: 13,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "MINISTRY OF HOME AFFAIRS",
                                          fontSize: 12,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "IMMIGRATION SERVICES DEPARTMENT",
                                          fontSize: 12,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "GOVERNMENT BILL",
                                          fontSize: 10,
                                          alignment: "center",
                                          bold: true,
                                          color: "blue",
                                        },
                                      ],
                                    ],
                                  },
                                },
                                {
                                  border: [false, false, false, false],
                                  stack: [
                                    {
                                      image:
                                        "data:image/jpeg;base64," +
                                        ImmLogo.logo,
                                      width: 60,
                                      height: 60,
                                      alignment: "right",
                                    },
                                  ],
                                },
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                },
              ],

              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["*"],
                    body: [
                      [
                        {
                          border: [false, true, false, false],
                          text: "",
                          fontSize: 14,
                          bold: true,
                          decorationStyle: "dotted",
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
              ],

              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["60%", "*"],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          table: {
                            widths: ["45%", "*"],
                            body: [
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Control Number :",
                                  fontSize: 12,
                                  alignment: "left",
                                  bold: true,
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.ControlNo,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Payment Ref:",
                                  fontSize: 12,
                                  alignment: "left",
                                  bold: true,
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.BillReference,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Service Provider Code:",
                                  fontSize: 12,
                                  alignment: "left",
                                  bold: true,
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.SpID,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Payer Name : ",
                                  fontSize: 12,
                                  alignment: "left",
                                  bold: true,
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.FullName,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Payer Phone : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.PhoneNo,

                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Amount in Words : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: `${amountToWords(billInfo?.Amount)} ${
                                    billInfo?.Currency
                                  }`,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Expires on : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.BillExpireDate,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Prepared By : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: billInfo?.BilledBy,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Printed By : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: userName,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Printed on : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: printedDate,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "Signature : ",
                                  bold: true,
                                  fontSize: 12,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: ":.......................................",
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                            ],
                          },
                        },
                        {
                          border: [false, false, false, false],
                          table: {
                            widths: ["15%", "*"],
                            body: [
                              [
                                {
                                  border: [false, false, false, false],
                                  text: "",
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: "",
                                  fontSize: 11,
                                  alignment: "left",
                                  bold: true,
                                  marginTop: 6,
                                },
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                },
              ],

              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["77%", "3%", "20%"],
                    body: [
                      [
                        {
                          border: [false, false, false, true],
                          text: "\nDescription",
                          fontSize: 12,
                          alignment: "left",
                          bold: true,
                        },
                        {
                          border: [false, false, false, true],
                          text: "",
                          fontSize: 11,
                          bold: true,
                          alignment: "right",
                        },
                        {
                          border: [false, false, false, true],
                          text: "\nAmount",
                          bold: true,
                          fontSize: 12,
                          alignment: "right",
                        },
                      ],
                      [
                        {
                          border: [false, false, false, true],
                          text: `Total Fee for ${billInfo?.BillDescription} `,
                          fontSize: 11,
                          alignment: "left",
                          marginTop: 5,
                          marginBottom: 5,
                        },
                        {
                          border: [false, false, false, true],
                          text: "",
                          fontSize: 11,
                          alignment: "right",
                          marginTop: 5,
                          marginBottom: 5,
                        },
                        {
                          border: [false, false, false, true],
                          text: `${billInfo?.Amount} ${billInfo?.Currency} `,
                          fontSize: 11,
                          alignment: "right",
                          marginTop: 5,
                          marginBottom: 5,
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["55%", "*"],
                    border: [false, false, false, false],
                    body: [
                      [
                        {
                          text: "Jinsi ya Kulipa",
                          border: [false, false, false, false],
                          bold: true,
                          style: "tableHeader",
                          margin: [5, 5, 5, 5],
                        },
                        {
                          text: "How to Pay",
                          border: [false, false, false, false],
                          bold: true,
                          style: "tableHeader",
                          margin: [5, 5, 5, 5],
                        },
                      ],

                      [
                        {
                          border: [false, false, false, false],
                          text: `1. Kupitia Benki: Fika tawi lolote au wakala wa benki. Namba ya kumbukumbu: ${billInfo.ControlNo}.`,
                          margin: [5, 5, 5, 5],
                        },
                        {
                          border: [false, false, false, false],
                          text: `1. Via Bank: Visit any branch or bank agent. Reference Number: ${billInfo.ControlNo}.`,
                          margin: [5, 5, 5, 5],
                        },
                      ],

                      [
                        {
                          border: [false, false, false, false],
                          stack: [
                            "2. Kupitia Mitandao ya Simu:",
                            {
                              border: [false, false, false, false],
                              ul: [
                                "Ingia kwenye menyu ya mtandao husika",
                                "Chagua 4 (Lipa Bili)",
                                "Chagua 5 (Malipo ya Serikali)",
                                `Ingiza ${billInfo.ControlNo} kama namba ya kumbukumbu`,
                              ],
                              margin: [10, 0, 0, 0],
                            },
                          ],
                          margin: [5, 5, 5, 5],
                        },
                        {
                          border: [false, false, false, false],
                          stack: [
                            "2. Via Mobile Network Operators (MNO): Enter to the respective USSD Menu of MNO",
                            {
                              border: [false, false, false, false],
                              ul: [
                                "Select 4 (Make Payments)",
                                "Select 5 (Government Payments)",
                                `Enter ${billInfo.ControlNo} as reference number`,
                              ],
                              margin: [10, 0, 0, 0],
                            },
                          ],
                          margin: [5, 5, 5, 5],
                        },
                      ],
                    ],
                  },
                },
              ],
            ],
          },
        },
      ],
    };

    pdfMake.createPdf(documentDefinition).getBase64((encodedString) => {
      if (encodedString) {
        resolve(encodedString);
      } else {
        reject("Failed to generate PDF");
      }
    });
  });
}
